module.exports = __webpack_public_path__ + "img/s2-img4.62271ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s2-img4.png
// module id = 410
// module chunks = 0